<ng-container *ngIf="isMobile; else notMobileTemplate">
	<app-mobile-messagerie
		#mobileMessagerie
		[currentUser]="currentUser"
		[isScrollNeeded]="isScrollNeeded"
		[conversations]="conversations"
		[usersForNewConversation]="usersForNewConversation"
		[isSendButtonDisabled]="isSendButtonDisabled"
		(sendMessageEmitter)="sendMessage($event)"
	></app-mobile-messagerie>
</ng-container>
<ng-template #notMobileTemplate>
	<app-browser-messagerie
		#browserMessagerie
		[currentUser]="currentUser"
		[conversations]="conversations"
		[usersForNewConversation]="usersForNewConversation"
		[isSendButtonDisabled]="isSendButtonDisabled"
		(sendMessageEmitter)="sendMessage($event)"
	>
	</app-browser-messagerie>
</ng-template>
